import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { LOGIN_PATH } from "utils/constants/paths";

const Login = Loadable(React.lazy(() => import("./View")));

export const LoginRoute: IRouteItem = {
  path: LOGIN_PATH,
  iconName: "",
  element: React.createElement(Login),
  showInDrawer: false,
};
